import tw, { styled } from 'twin.macro';

const MarkdownOrderedListItem = styled.li`
  ${tw`py-1`}
`;

export default MarkdownOrderedListItem;
